import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';
import { PRODUCT_TYPE_COLORS, PRODUCT_TYPES } from 'admin/products/productUtils';
import { FinancialProductType } from 'generated/graphql';
import { Cell, Label, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';

interface Props {
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  products?: any[];
}

export const ProductsTypeChart: React.FC<Props> = ({ isLoading, products }) => {
  const typeCounts = Object.fromEntries(
    Object.entries(PRODUCT_TYPES).map(([type, name]) => [
      type as FinancialProductType,
      {
        color: PRODUCT_TYPE_COLORS[type as FinancialProductType],
        lastWeekCount: 0,
        name: name as string,
        totalCount: 0,
        type: type as FinancialProductType,
      },
    ]),
  );

  const lastWeekTimestamp = new Date();
  lastWeekTimestamp.setDate(lastWeekTimestamp.getDate() - 7);

  products?.forEach((product) => {
    typeCounts[product.type].totalCount++;
    if (product.creationTimestamp >= lastWeekTimestamp) {
      typeCounts[product.type].lastWeekCount++;
    }
  });
  const typeItems = Object.values(typeCounts)
    .filter((item) => item.totalCount > 0)
    .map((item) => ({
      color: item.color,
      name: item.name,
      type: item.type,
      value: item.totalCount,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  const typeItemsLastWeek = Object.values(typeCounts)
    .filter((item) => item.lastWeekCount > 0)
    .map((item) => ({
      color: item.color,
      name: item.name,
      type: item.type,
      value: item.lastWeekCount,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return isLoading ? (
    <Skeleton height={404} variant="rectangular" />
  ) : (
    <Card>
      <CardHeader title="Produkty podľa typu" />
      <CardContent>
        <ResponsiveContainer minHeight={300}>
          <PieChart
            margin={{
              bottom: -25,
              top: -25,
            }}
          >
            <Legend verticalAlign="top" />
            <Pie
              cx="30%"
              cy="50%"
              data={typeItems}
              dataKey="value"
              endAngle={-180}
              fill="#8884d8"
              innerRadius={60}
              label
              outerRadius={70}
              startAngle={180}
            >
              <Label fill="#000000" position="center">
                spolu
              </Label>
              {typeItems.map((item) => (
                <Cell key={`cell-${item.type}`} fill={item.color} />
              ))}
            </Pie>
            <Pie
              cx="70%"
              cy="50%"
              data={Object.values(typeItemsLastWeek)}
              dataKey="value"
              endAngle={-180}
              fill="#8884d8"
              innerRadius={60}
              label
              legendType="none"
              outerRadius={70}
              startAngle={180}
            >
              <Label fill="#000000" position="center" width="90%">
                posledných 7 dní
              </Label>
              {Object.values(typeItemsLastWeek).map((entry) => (
                <Cell key={`cell-${entry.type}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
